import en from './en';
import rs from './rs';

export default {
  en, rs
}
